import { Outlet, useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/admin-design/_common'
import { api } from '@/api/client'

const navItems = [
  { to: '/', label: 'Dashboard', end: true },
  { to: '/test', label: 'Test' },
  { to: '/api-keys', label: 'API Keys' },
  { to: '/jobs', label: 'Jobs' },
  { to: '/settings', label: 'Settings' },
]

export default function Layout() {
  const nav = useNavigate()
  const onLogout = async () => {
    try {
      await api.logout()
    } finally {
      nav('/login')
    }
  }
  return (
    <AdminLayout brand="BrowserSaas" navItems={navItems} onLogout={onLogout}>
      <Outlet />
    </AdminLayout>
  )
}
